export const adminPartnersApi = {

    getAll () {
        return axios.get(`/api/admin/partner`)
    },

}
